import React, {useEffect, useRef, useState} from 'react';
import { ItemContainer, ChildContainer, NameContainer, ItemName, Column } from '../styles';
import { RetractableButton, State } from '../../Components';
// import ManutencaoIcon from '../ManutencaoIcon';
// import ComunicationIcon from '../ComunicationIcon';
// import CriticoIcon from '../CriticoIcon';
// import AdvertenciaIcon from '../AdvertenciaIcon';
// import NonAlarm from '../NonAlarm';
import { ManutencaoIcon, ComunicationIcon, CriticoIcon, AdvertenciaIcon, NonAlarm } from '../../Components';

const ContainerSubItens = ({item, allowEdit, addComand, children, showItens, invisible, showAlarms, alarm, isNewValue}) => {
    let childs = React.Children.toArray(children);
    let Active = (item.cards_comando.comandoPoco.active);
    const [showElements, setShowElements] = useState(item.cards_comando.comandoPoco.active);
    const [currentState, setCurrentState] = useState(parseInt(item.cards_comando.switchvariable?.valor) === 1);
    const hasState = useRef(item.cards_comando?.switchvariable?.isSwitch);
    const name = useRef(item.cards_comando.name);

    useEffect(() => {
        setCurrentState(parseInt(item.cards_comando.switchvariable?.valor) === 1);
        Active = (item.cards_comando.comandoPoco.active);
        hasState.current = item.cards_comando?.switchvariable?.isSwitch;
        name.current = item.cards_comando.name;
        childs = React.Children.toArray(children);
    }, [item, children])

    // Função para buscar o nivel de alerta
    const getAlarm = (valor, l, ll, h, hh) => {
        if(ll != null && (hh === null || hh === undefined) && ll === l && ll !== 0){
            return 6
        }
        if(hh != null && (ll === null || ll === undefined) && hh === h && hh !== 0){
            return 6
        }
        if(hh === h && ll === l && hh === ll){
            return 6
        }
        if(ll != null && ll !== 0){
            if (parseFloat(valor) <= parseFloat(ll)){
                return 2;
            }
        }
        if(hh != null && hh !== 0){
            if (parseFloat(valor) >= parseFloat(hh)){
                return 2;
            }
        }
        if(l != null && l !== 0){
            if (parseFloat(valor) <= parseFloat(l)){
                return 1;
            }
        }
        if(h != null && h !== 0){
            if (parseFloat(valor) >= parseFloat(h)){
                return 1;
            }
        }
        return 0;
    }

    const getPumpAlarm = (valor, l, ll, h, hh) => {
        if(ll != null && ll !== 0){
            if (parseFloat(valor) <= parseFloat(ll)){
                return 2;
            }
        }
        if(hh != null && hh !== 0){
            if (parseFloat(valor) >= parseFloat(hh)){
                return 2;
            }
        }
        if(l != null){
            if (parseFloat(valor) <= parseFloat(l)){
                return 1;
            }
        }
        if(h != null){
            if (parseFloat(valor) >= parseFloat(h)){
                return 1;
            }
        }
        return 0;
    }

    // Função para retornar o elemento de contador de alarmes no item
    const countAlarms = () => {
        let cont = 0
        let newalarm = 0;
        
        children.map(subitem => {
            let status = 0;
            if(subitem.props.Alarms?.alarmHH && subitem.props.Alarms?.alarmH && subitem.props.Alarms?.alarmL && subitem.props.Alarms?.alarmLL){
                if(subitem.props.isBomb){
                    status = getPumpAlarm(subitem.props.VariableValue, subitem.props.Alarms.alarmL.variavel.valor, 
                        subitem.props.Alarms.alarmLL.variavel.valor, subitem.props.Alarms.alarmH.variavel.valor, subitem.props.Alarms.alarmHH.variavel.valor)
                }else{
                    status = getAlarm(subitem.props.VariableValue, subitem.props.Alarms.alarmL.variavel.valor, 
                    subitem.props.Alarms.alarmLL.variavel.valor, subitem.props.Alarms.alarmH.variavel.valor, subitem.props.Alarms.alarmHH.variavel.valor)
                }
            
            }else if(subitem.props.Alarms?.alarmHH && subitem.props.Alarms?.alarmH){
                if(subitem.props.isBomb){
                    status = getPumpAlarm(subitem.props.VariableValue, null, 
                        null, subitem.props.Alarms.alarmH.variavel.valor, subitem.props.Alarms.alarmHH.variavel.valor)
                }else{
                    status = getAlarm(subitem.props.VariableValue, null, 
                    null, subitem.props.Alarms.alarmH.variavel.valor, subitem.props.Alarms.alarmHH.variavel.valor)
                }
            }else if(subitem.props.Alarms?.alarmLL && subitem.props.Alarms?.alarmL){
                if(subitem.props.isBomb){
                    status = getPumpAlarm(subitem.props.VariableValue, subitem.props.Alarms.alarmL.variavel.valor, 
                        subitem.props.Alarms.alarmLL.variavel.valor, null, null)
                }else{
                    status = getAlarm(subitem.props.VariableValue, subitem.props.Alarms.alarmL.variavel.valor, 
                        subitem.props.Alarms.alarmLL.variavel.valor, null, null)
                }
            }
            if(status>0){
                cont=cont+1; 
                newalarm = status > newalarm ? status : newalarm;
            }
        })

        if(alarm === 3 || alarm === '3' ){
            return (
                <ComunicationIcon/>
            )
        }else if(alarm === 4 || alarm === '4'){
            return (
                <ManutencaoIcon/>
            )
        }else if(newalarm === 2 || newalarm === '2'){
            return(
                <CriticoIcon number={cont}/>
            )
        }else if(newalarm === 1 || newalarm === '1'){
            return(
                <AdvertenciaIcon number={cont}/>
            )
        }else if((newalarm === 6 || newalarm === '6') && Active){
            return(
                <NonAlarm/>
            )
        }
        return <></>;
    }

    // Função para alterar de state do switch
    const onChange = (newState) => {
        ComandConstructor(item.cards_comando.switchvariable?.id, newState, item.cards_comando.switchvariable?.valor, () => {setCurrentState(parseInt(item.cards_comando.switchvariable?.valor) === 1)}, 'state')
        setCurrentState(newState);
    }

    // Função para construir o comando e adicionar a lista
    const ComandConstructor = (comandId, value, oldvalue, cancelComand, type) => {
        addComand([comandId, value], oldvalue, item.cards_comando.name, cancelComand, type);
    }

    // Função para retrar os itens
    const OnRetractable = () =>{
        setShowElements(!showElements);
    }

    return (
        <ItemContainer $Active={Active && !allowEdit} $invisible={invisible}>
            <NameContainer>
                <Column $width={'8%'}>
                    {countAlarms()}
                </Column>
                    {hasState.current ? 
                        <Column $width={'10%'}/>
                    :
                        <></>
                    }
                <ItemName onClick={() => showItens()}>
                    {name.current}
                </ItemName>
                {hasState.current ?
                    <Column $width={'10%'}>
                        <State isNewValue={isNewValue} State={currentState} onChange={(newState) => onChange(newState)} disabled={!Active || allowEdit}/>
                    </Column>
                :
                    <></>
                }
                <Column $width={'8%'}>
                    <RetractableButton onclick={OnRetractable}/>
                </Column>   
            </NameContainer>
            <ChildContainer $Active={Active && !allowEdit} $show={showElements}>
                {childs.map((child, index) => {
                    if(index%2 === 0){
                        let newProps = {
                            ...child.props,
                            background: '#fff',
                        };
                        return React.cloneElement(child, newProps);
                    }
                    return (child)
                }) }
            </ChildContainer>
        </ItemContainer>
    );
}

export default ContainerSubItens;